import { render, staticRenderFns } from "./AccountEmailVolumeMonthlyUsage.vue?vue&type=template&id=7387c960&scoped=true"
import script from "./AccountEmailVolumeMonthlyUsage.vue?vue&type=script&lang=js"
export * from "./AccountEmailVolumeMonthlyUsage.vue?vue&type=script&lang=js"
import style0 from "./AccountEmailVolumeMonthlyUsage.vue?vue&type=style&index=0&id=7387c960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7387c960",
  null
  
)

export default component.exports